module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Harper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karen Harper is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" and"), _c('I', [_vm._v(" USA TODAY")]), _vm._v(" bestselling author of romantic suspense. A former Ohio State University English instructor, she now writes full time. Harper is the winner of The Mary Higgins Clark Award for her novel, DARK ANGEL. She also writes historical novels set in Tudor England.  Please visit or write her at her website at  "), _c('a', {
    attrs: {
      "href": "http://www.KarenHarperAuthor.com"
    }
  }, [_vm._v("www.KarenHarperAuthor.com")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/njeHW0/tc-custom/9781488091414.jpg?1728726041438",
      "alt": "This image is the cover for the book Below the Surface"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Below the Surface\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A diver is alone in shark-infested waters after her twin sister abandons her in this romantic suspense mystery by a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Briana Devon knows her twin sister would never deliberately leave her—but when she emerges from underwater, Daria and their boat have vanished. Fighting rough waves and a fast-approaching storm, Bree doesn’t have time to question: if she wants to survive, she has to swim. Exhausted and terrified, Bree barely makes it to a tiny barrier island, where Cole De Roca, who has also taken shelter, revives her. Bound to Cole by the harrowing experience, she turns to him as she struggles to understand what happened to her sister. What was her twin, whom she thought she knew so well, hiding? What really transpired that terrible afternoon? And what secrets lie dormant . . . below the surface?"), _c('br'), _c('br'), _c('b', [_vm._v("“"), _c('i', [_vm._v("Below the Surface")]), _vm._v(" is a well plotted mystery that had me guessing until its exciting conclusion. . . . A nice mystery to curl up with on the beach this summer.” —"), _c('i', [_vm._v("Fresh Fiction")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0